// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"0b65d325","952":"69cd798b"}[chunkId] + ".chunk.js";
};